module.exports = __webpack_public_path__ + "img/arrowLeft.5b859883.svg";